import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { P } from '../../../base/typography';
import UploadFiles from '../../../uploadFiles';
import { useMultiStepFormContext } from '../../context/multistepContext';
import { useTranslationsContext } from '../../context/translationsContext';
import { FormStepProps } from '../../sendReceiptMultistep';
import {
	ButtonWrapper,
	ErrorMessage,
	FormStepHeading,
	Label,
	PrevButton,
	PrevButtonMobile,
	ProceedButton,
} from '../../sendReceiptMultistep.styles';
import * as StyledInstructionToStaff from './InstructionToStaff.styles';

export default function SendAnInvoice({ values, setFieldTouched, touched, errors }: FormStepProps) {
	const translations = useTranslationsContext();
	const { next, prev } = useMultiStepFormContext();
	const { t } = useTranslation('sendReceiptMultistep');

	useEffect(() => {
		if (values.files.length !== 0) {
			setFieldTouched('files', true);
		}
	}, [values, setFieldTouched]);

	const isStepComplete =
		values.files.length > 0 && values.additionalInformation && !errors.files && !errors.additionalInformation;

	return (
		<>
			<PrevButtonMobile
				onClick={e => {
					e.stopPropagation();
					prev();
				}}>
				{translations?.prevStepMobile || t('prevStepMobile')}
			</PrevButtonMobile>
			<FormStepHeading>
				{translations?.formStepTitles?.type?.hasInvoice || t('formStepTitles.type.hasInvoice')}
			</FormStepHeading>
			<P>{translations?.validReceipt || t('validReceipt')}</P>
			<StyledInstructionToStaff.FieldWrapper>
				<Label marginBottom={'1rem'}>{translations?.sendAFile || t('sendAFile')}*</Label>
				<UploadFiles name="files" />
				{touched.files && errors.files && (
					<ErrorMessage>
						{translations?.shipment?.errors[errors.files as keyof typeof translations.shipment.errors] ||
							t(`shipment.errors.${errors.files}`)}
					</ErrorMessage>
				)}
			</StyledInstructionToStaff.FieldWrapper>
			<StyledInstructionToStaff.FieldWrapper>
				<Label>{translations?.contentDescription || t('contentDescription')}*</Label>
				<StyledInstructionToStaff.TextArea
					maxLength="254"
					type="text"
					id="additionalInformation"
					name="additionalInformation"
					component="textarea"
					padding="1rem"
					placeholder={`${translations?.descriptionPlaceholder || t('descriptionPlaceholder')}`}
				/>
				{touched.additionalInformation && errors.additionalInformation && (
					<ErrorMessage>
						{translations?.recipient?.errors?.[errors.additionalInformation] ||
							t(`recipient.errors.${errors.additionalInformation}`)}
					</ErrorMessage>
				)}
			</StyledInstructionToStaff.FieldWrapper>
			<ButtonWrapper>
				<PrevButton
					onClick={e => {
						e.stopPropagation();
						prev();
					}}>
					{translations?.prevStep || t('prevStep')}
				</PrevButton>
				<ProceedButton
					type="button"
					onClick={e => {
						e.stopPropagation();
						next();
					}}
					disabled={!isStepComplete}>
					{translations?.nextStep || t('nextStep')}
				</ProceedButton>
			</ButtonWrapper>
		</>
	);
}
